import { Switch, useTheme } from "@monolith-forensics/monolith-ui";
import { useQueryClient } from "@tanstack/react-query";
import CustomFieldsAPI from "@/api/CustomFields";
import ItemBox from "@/components/ItemBox/ItemBox.js";
import { CUSTOM_FIELD_CATEGORIES } from "@/pages/Settings/CustomFieldSettings/utils/customFieldConstants";

export const CustomFields: React.FC<{
  customFields: any;
  type: string;
}> = ({ customFields, type }) => {
  const theme = useTheme();
  const queryClient = useQueryClient();

  const handleUpdate = (values: any) => {
    CustomFieldsAPI.updateCustomField(values);

    queryClient.setQueryData(
      [
        type === "evidence" ? "customEvidenceFields" : "customInquiryFields",
        {
          category:
            type === "evidence"
              ? CUSTOM_FIELD_CATEGORIES.EVIDENCE
              : CUSTOM_FIELD_CATEGORIES.INQUIRY,
        },
      ],
      (oldData: any) => {
        return (oldData || []).map((field: any) => {
          if (field.field_id === values.field_id) {
            return {
              ...field,
              external_enabled: values.external_enabled,
            };
          }
          return field;
        });
      }
    );
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
        gridGap: 20,
      }}
    >
      {customFields.map((field: any) => {
        let description = field.description
          ? field.description
          : "No description provided.";

        if (description.length > 25) {
          description = description.substring(0, 25) + "...";
        }

        return (
          <ItemBox
            key={field.field_id}
            title={field.field_name}
            subTitle={`${description}`}
            subTitleHint={field.description}
            endIcon={
              <div
                style={{
                  display: "flex",
                  alignItems: "end",
                }}
              >
                <span
                  style={{
                    fontSize: 10,
                    color: theme.palette.text.secondary,
                    marginRight: 5,
                  }}
                >
                  Enabled
                </span>
                <Switch
                  size="xs"
                  defaultValue={field.external_enabled}
                  onChange={(value) =>
                    handleUpdate({
                      external_enabled: value,
                      field_id: field.field_id,
                    })
                  }
                />
              </div>
            }
          />
        );
      })}
    </div>
  );
};
